import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/providers/auth-provider";
import { WorkspaceLayout } from "@/components/workspace-layout";
import { PageTitleProvider } from "@/contexts/page-title-context";
import { appNavigation } from "@root/config/navigation";

export function AiChatProtectedLayout() {
  const { loading, user } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-brand-25">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-brand-200 border-t-brand-500" />
      </div>
    );
  }

  if (!user) return null;

  return <Outlet />;
}

export function ProtectedLayout() {
  const { loading, user, logout } = useAuth();
  const { pathname } = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-brand-25">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-brand-200 border-t-brand-500" />
      </div>
    );
  }

  if (!user) {
    return null;
  }

  const handleLogout = () => {
    logout();
  };

  return (
    <PageTitleProvider>
      <WorkspaceLayout
        userName={user?.display_name || user?.name}
        userStaffId={user?.staff_id}
        onLogout={handleLogout}
        sections={appNavigation}
        menuVariant="default"
        userRole={user?.role}
      >
        <Outlet />
      </WorkspaceLayout>
    </PageTitleProvider>
  );
}
